import { watchRoutes } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function WatchRoutes() {
  return (
    <section id="routes" className="w-full border-b border-foreground-900/10 bg-background-100">
      <div className="mx-auto w-full max-w-[1360px] px-4 py-16 md:px-8 md:py-24">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-3 lg:gap-16">
          <div className="lg:sticky lg:top-32 lg:self-start">
            <SectionHeading
              index="03"
              kicker="在哪看 · 观看路径"
              title="四条路，把顺序走对"
              description="信息乱的时候，问题往往不是没入口，而是先看了不该先看的那一条。按下面的顺序走会顺很多。"
            />
            <a
              href="#index"
              className="mt-8 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-900/20 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              直达速查索引
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-down-line"></i>
              </span>
            </a>
          </div>

          <div className="lg:col-span-2">
            {watchRoutes.map((route, index) => (
              <div key={route.id} className="relative flex gap-5 pb-9 last:pb-0">
                <div className="flex flex-col items-center">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-foreground-900/15 bg-background-50 text-lg text-primary-600">
                    <i className={route.icon}></i>
                  </span>
                  {index < watchRoutes.length - 1 ? (
                    <span className="mt-2 w-px flex-1 bg-foreground-900/15"></span>
                  ) : null}
                </div>
                <div className="pb-2">
                  <span className="text-xs tracking-[0.28em] text-foreground-500">
                    {route.step}
                  </span>
                  <h3 className="mt-2 font-heading text-lg text-foreground-950 md:text-xl">
                    {route.title}
                  </h3>
                  <p className="mt-2.5 max-w-xl text-sm leading-relaxed text-foreground-600">
                    {route.summary}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}